import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCopyIconProps extends SvgIconProps {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfAcdIcon />
 * @returns SVG of align center Icon
 */
export function CcfCopyIcon(props: CcfCopyIconProps) {
  return (
    <SvgIcon
      {...props}
      width="26"
      height="26"
      viewBox="0 0 22 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 0H6C4.9 0 4 0.9 4 2V4H2C0.9 4 0 4.9 0 6V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0V0ZM14 14V18H2V6H14V14ZM18 14H16V6C16 4.9 15.1 4 14 4H6V2H18V14Z"
        fill="#3F5C69"
      />
    </SvgIcon>
  );
}

export default CcfCopyIcon;
